
const HEADER = [
  {
    title: '유저 관리',
    menus: [
      { name: '유저 관리', url:'/user', id: 'M0002' },
    ]
  },
  {
    title: '업체 관리',
    menus: [
      { name: '업체 정보 관리', url:'/enterprise', id: 'M0001' },
      { name: '상품 전시 관리', url:'/display', id: 'M0006' },
      { name: '상품 라벨 관리', url:'/label', id: 'M0007'},
    ]
  },
  {
    title: '상품정보관리',
    menus: [
      {name: '제주스냅 관리', url: '/jejusnap', id: 'M0011'},
      {name: '본식스냅 관리', url: '/mainsnap', id: 'M0012'},
      {name: '심플스튜디오 관리', url: '/simple', id: 'M0013'},
      {name: '드레스·메이크업 관리', url: '/dme', id: 'M0014'},
      {name: '본식DVD 관리', url: '/dvd', id: 'M0017'}
    ]
  },
  {
    title: '상품 관리',
    menus: [
      { name: '상품 결제 관리', url:'/payment', id: 'M0017' },
      { name: '기획전 관리', url: '/plan', id: 'M0022'},
      { name: '문의대행 관리', url: '/proxy', id: 'M0023'},
      { name: '문의대행 담당자 관리', url: '/proxy-rule', id: 'M0024'},
    ]
  },
  /*{
    title: '이벤트 관리',
    menus: [
      { name: '이벤트 관리', url:'/events', id: 'M0004' },
    ]
  },*/
  {
    title: '사이트 관리',
    menus: [
      { name: '웨딩홀 관리', url: '/weddinghall', id: 'M0018' },
//      { name: '배너 관리', url: '/banner', id: 'M0008' },
    ]
  },
  {
    menus: [
      { name: '로그아웃', url: '/admin/logout', id: 'non_auth' },
    ]
  }
];

export default HEADER;



// WEBPACK FOOTER //
// ./client/components/BaseComponent/Menus/AdminMenu.js